<template>
    <hmenu></hmenu>

          <main>
            <section class="breadcrumb-height ns-breadcrumb-area" style="min-height: 300px; background-image: url('/assets/img/breadcrumb/breadcrumb-bg.jpg');" >
                <img src="/assets/img/breadcrumb/shape-1.png" alt="" class="ns-breadcrumb-shape-1">
                <img src="/assets/img/breadcrumb/breadcrumb-map.png" alt="" class="ns-breadcrumb-map">
                <img src="/assets/img/breadcrumb/shape-2.png" alt="" class="ns-breadcrumb-shape-2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="ns-breadcrumb-wrap text-center">
                                <h2 class="ns-breadcrumb-title">Kontakti</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="pt-115">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-7 col-lg-6">
                            <div v-if="!sukses" class="ns-contact-left ns-contact-page mb-55">
                                <div class="ns-section mb-35">
                                    <span class="ns-section-subtitle">Për më shumë informata na kontaktoni!</span>
                                </div>
                                <div class="ns-contact-form">
                                      <form @submit.prevent="sendMail" id="form" class="form">

                                        <p v-if="error" style="text-align: center; color:red"><b>Ju lutem plotesoni të gjitha fushat</b></p>
                                        <p v-if="error1" style="text-align: center; color:red"><b>Gabim në dërgimin e mesazhit ju lutem provoni përsëri</b></p>

                                        <div class="row">
                                            <div class="col-sm-6">
                                                <input v-model="form.emri" type="text" placeholder="Emri *" :class="(emri_error)?'input_error':''" >
                                            </div>
                                            <div class="col-sm-6">
                                                <input v-model="form.mbiemri" type="text" placeholder="Mbiemri *" :class="(mbiemri_error)?'input_error':''">
                                            </div>
                                            <div class="col-sm-6">
                                                <input v-model="form.email" type="email" placeholder="Email *" :class="(email_error)?'input_error':''" >
                                            </div>
                                            <div class="col-sm-6">
                                                <input v-model="form.tel" type="number" placeholder="Telefoni *" :class="(tel_error)?'input_error':''" >
                                            </div>
                                            <div class="col-12">
                                                <textarea v-model="form.msg" name="message" cols="30" rows="10" placeholder="Mesazhi" :class="(msg_error)?'input_error':''"></textarea>
                                            </div>
                                            <div class="col-12">
                                                <button v-if="!busy"  type="submit" class="ns-theme-btn ns-contact-btn">Dërgo</button>
                                                <button v-else type="button" disabled class="ns-theme-btn ns-contact-btn">Ju lutem prisni ...</button>
                                            </div>
                                        </div>
                                      </form>
                                </div>
                            </div>
                            <div v-else class="ns-contact-left ns-contact-page mb-55">
                                <div class="ns-contact-form">
                                   <div class="row contact">
                                      <div class="col-12">
                                          <h4 style="color: green;" >Mesazhi ësht dërguar me sukses</h4>
                                          <h5 style="color: green;" >Dikush nga stafi do të ju kontaktoj shum shpejt. Ju faliminderit!</h5>
                                      </div>
                                  </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-5 col-lg-6">
                            <div class="ns-contact-info mb-55">
                                <span class="ns-contact-circle-1"></span>
                                <span class="ns-contact-circle-2"></span>
                                <img src="/asetet/contact.png" class="ns-contact-bg-img">
                                <div class="ns-contact-item ns-phone">
                                    <div class="ns-contact-item-icon">
                                        <i class="icofont-ui-call"></i>
                                    </div>
                                    <div class="ns-contact-item-details">
                                        <a href="tel:+38349200203">+383 49 200 203</a>
                                        <a href="tel:+38345694444">+383 45 694 444</a>
                                    </div>
                                </div>
                                <div class="ns-contact-item ns-mail">
                                    <div class="ns-contact-item-icon">
                                        <i class="icofont-envelope"></i>
                                    </div>
                                    <div class="ns-contact-item-details">
                                        <span>Email</span>
                                        <a href="info@gpro-ks.com">info@gpro-ks.com</a>
                                    </div>
                                </div>
                                <div class="ns-contact-item ns-address">
                                    <div class="ns-contact-item-icon">
                                        <i class="icofont-location-pin"></i>
                                    </div>
                                    <div class="ns-contact-item-details">
                                        <span>Adresa</span>
                                        <p>Rr. Zhuj Selmani PN, Pejë, Kosovë</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </main>
    <Footer></Footer>
</template>

<script>
    import hmenu from './header.vue'
    import Footer from './Footer.vue'

    import blogService from "@/api/blogService";

    export default {

        data () {
          return {

           sukses:false,
            busy:false,
            error:false,
            emri_error:false,
            mbiemri_error:false,
            email_error:false,
            tel_error:false,
            msg_error:false,
            error1:false,

            form:{
                emri:'',
                mbiemri:'',
                email:'',
                tel:'',
                msg:'',
            }


          }
        },


        components: {
          hmenu,
          Footer,
          blogService,
         
        },




        methods:{

            async sendMail(){
              console.log('asdasd')
                this.busy = true 
                this.error = false

                if(this.form.emri.length < 3){
                    this.emri_error = true
                    this.error = true
                    this.busy = false 
                }else{
                    this.emri_error = false
                }

                if(this.form.mbiemri.length < 3){
                    this.mbiemri_error = true
                    this.error = true
                    this.busy = false 
                }else{
                    this.mbiemri_error = false
                }

                if(this.form.email.length < 3){
                    this.email_error = true
                    this.error = true
                    this.busy = false 
                }else{
                    this.email_error = false
                }

                if(this.form.tel.length < 3){
                    this.tel_error = true
                    this.error = true
                    this.busy = false 
                }else{
                    this.tel_error = false
                }

                if(this.form.msg.length < 3){
                    this.msg_error = true
                    this.error = true
                    this.busy = false 
                }else{
                    this.msg_error = false
                }



              if (this.error) return;

              this.busy = true;

              try {
                  const response = await blogService.sendMail(this.form);
                  if (response.data == "sukses") {
                      this.sukses = true;
                      this.error1 = false;
                  } else {
                      this.sukses = false;
                      this.error1 = true;
                  }
              } catch (error) {
                  console.log(error);
                  this.sukses = false;
              }
              this.busy = false;


          }





        },



        mounted(){

          window.scrollTo({top: 0, behavior: 'smooth'});

        }


    }

</script>



<style>
  .input_error{
    border-color: #ff0000!important;
  }

  .ns-project-details-listt ul li {
      display: flex;
      align-items: center;
      line-height: 1;
      margin-bottom: 20px;
      gap: 5px;
      font-size: 17px;
      color: var(--clr-body-text);
  }



  .kioska__ ul li{
    line-height: 1!important;
    margin-bottom: 0px!important;
    gap: 5px!important;
  }


  .hyrja__ ul li{
    line-height: 1!important;
    margin-bottom: 0px!important;
    gap: 5px!important;
  }

  .para li{
    flex-wrap: wrap!important;
  }

</style>